var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Vue, Component } from 'vue-property-decorator';
import moment from "moment";
import mapSort from "mapsort";
import { isNullOrUndefined } from 'util';
import { PaymentMethod } from '../types/PaymentMethod';
var SortableTable = /** @class */ (function (_super) {
    __extends(SortableTable, _super);
    function SortableTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortedBy = "";
        _this.sortedAsc = null;
        _this.srSortedBy = "";
        _this.sortKey = "";
        return _this;
    }
    SortableTable.prototype.sort = function (by, toSort, isHistory) {
        if (isHistory === void 0) { isHistory = null; }
        if (this.sortedBy == by) {
            if (this.sortedAsc == null)
                this.sortedAsc = true;
            else if (this.sortedAsc == true)
                this.sortedAsc = false;
            else if (this.sortedAsc == false) {
                this.sortedAsc = null;
                this.sortedBy = "";
            }
        }
        else {
            this.sortedBy = by;
            this.sortedAsc = true;
        }
        return this.doSort(toSort, isHistory);
    };
    SortableTable.prototype.doSort = function (toSort, isHistory) {
        var _this = this;
        if (isHistory === void 0) { isHistory = null; }
        var result = [];
        if (this.sortedAsc == null) {
            result = __spread(toSort);
            this.srSortedBy = this.$t("Accessibility.NotSorted");
            return result;
        }
        var sortHeader = "";
        var asc = this.sortedAsc;
        switch (this.sortedBy) {
            case null:
                result = __spread(toSort);
                this.srSortedBy = this.$t("Accessibility.NotSorted");
                break;
            case "amount":
                if (isHistory) {
                    sortHeader = this.$t("Payments.PaidAmount");
                }
                else {
                    sortHeader = this.$t("Payments.SumToBePaid");
                }
                result = mapSort(toSort, function (entry) {
                    return { amount: asc ? entry.amount : -entry.amount };
                }, function (a, b) {
                    return a.amount - b.amount;
                });
                break;
            case "arrivalOrCreatedDate":
                sortHeader = this.$t("Created");
                result = mapSort(toSort, function (entry) {
                    return { arrivalOrCreatedDate: entry.arrivalOrCreatedDate };
                }, function (a, b) {
                    var momentA = moment(a.arrivalOrCreatedDate);
                    var momentB = moment(b.arrivalOrCreatedDate);
                    if ((momentA > momentB))
                        return asc ? 1 : -1;
                    if ((momentA < momentB))
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "correspondenceDeadline":
                sortHeader = this.$t("Deadline");
                result = mapSort(toSort, function (entry) {
                    return { deadline: entry.latestMessage.deadline };
                }, function (a, b) {
                    var momentA = moment(a.deadline);
                    var momentB = moment(b.deadline);
                    if ((momentA > momentB))
                        return asc ? 1 : -1;
                    if ((momentA < momentB))
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "correspondenceHeader":
                sortHeader = this.$t("Correspondence.Header");
                result = mapSort(toSort, function (entry) {
                    return { header: entry.firstMessage.header.toLowerCase() };
                }, function (a, b) {
                    if (isNullOrUndefined(a.header) && isNullOrUndefined(b.header))
                        return 0;
                    if (isNullOrUndefined(a.header))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.header))
                        return asc ? -1 : 1;
                    if (a.header > b.header)
                        return asc ? 1 : -1;
                    if (a.header < b.header)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "correspondenceMessage":
                sortHeader = this.$t("Correspondence.Message");
                result = mapSort(toSort, function (entry) {
                    return { message: entry.latestMessage.message.toLowerCase() };
                }, function (a, b) {
                    if (isNullOrUndefined(a.message) && isNullOrUndefined(b.message))
                        return 0;
                    if (isNullOrUndefined(a.message))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.message))
                        return asc ? -1 : 1;
                    if (a.message > b.message)
                        return asc ? 1 : -1;
                    if (a.message < b.message)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "correspondenceState":
                sortHeader = this.$t("State");
                result = mapSort(toSort, function (entry) {
                    return { state: entry.state };
                }, function (a, b) {
                    if (a.state > b.state)
                        return asc ? 1 : -1;
                    if (a.state < b.state)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "correspondenceTarget":
                sortHeader = this.$t("AidTargetNumber");
                result = mapSort(toSort, function (entry) {
                    if (isNullOrUndefined(entry.aidtargetNumber))
                        return { aidTargetNumber: undefined, aidType: undefined };
                    var split = entry.aidtargetNumber.split(/(\d+)/);
                    if (split.length == 1)
                        return { aidTargetNumber: 0, aidType: split[0].trim().toLowerCase() };
                    else
                        return { aidTargetNumber: Number(split[1].trim()), aidType: split[0].trim().toLowerCase() };
                }, function (a, b) {
                    if (isNullOrUndefined(a.aidType) && isNullOrUndefined(b.aidType))
                        return 0;
                    if (isNullOrUndefined(a.aidType))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.aidType))
                        return asc ? -1 : 1;
                    if (a.aidType > b.aidType)
                        return asc ? 1 : -1;
                    if (a.aidType < b.aidType)
                        return asc ? -1 : 1;
                    if (isNullOrUndefined(a.aidTargetNumber) && isNullOrUndefined(b.aidTargetNumber))
                        return 0;
                    if (isNullOrUndefined(a.aidTargetNumber))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.aidTargetNumber))
                        return asc ? -1 : 1;
                    return asc ? a.aidTargetNumber - b.aidTargetNumber : b.aidTargetNumber - a.aidTargetNumber;
                });
                break;
            case "date":
                sortHeader = this.$t("Date");
                result = mapSort(toSort, function (entry) {
                    return { date: entry.latestActionDate };
                }, function (a, b) {
                    var momentA = moment(a.date);
                    var momentB = moment(b.date);
                    if ((momentA > momentB))
                        return asc ? 1 : -1;
                    if ((momentA < momentB))
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "deadline":
                sortHeader = this.$t("Deadline");
                result = mapSort(toSort, function (entry) {
                    return { showDeadline: entry.showDeadline, deadline: entry.deadline };
                }, function (a, b) {
                    if (!a.showDeadline && !b.showDeadline)
                        return 0;
                    if (!a.showDeadline)
                        return asc ? 1 : -1;
                    if (!b.showDeadline)
                        return asc ? -1 : 1;
                    var momentA = moment(a.deadline);
                    var momentB = moment(b.deadline);
                    if ((momentA > momentB))
                        return asc ? 1 : -1;
                    if ((momentA < momentB))
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "method":
                sortHeader = this.$t("Payments.PaymentMethod");
                result = mapSort(toSort, function (entry) {
                    return { method: _this.paymentMethod(entry) };
                }, function (a, b) {
                    if (isNullOrUndefined(a.method) && isNullOrUndefined(b.method))
                        return 0;
                    if (isNullOrUndefined(a.method))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.method))
                        return asc ? -1 : 1;
                    if (a.method > b.method)
                        return asc ? 1 : -1;
                    if (a.method < b.method)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "paymentDate":
                if (isHistory) {
                    sortHeader = this.$t("Payments.PaymentDate");
                }
                else {
                    sortHeader = this.$t("Payments.PlannedPaymentDate");
                }
                result = mapSort(toSort, function (entry) {
                    return { paymentDate: entry.paymentDate };
                }, function (a, b) {
                    var momentA = moment(a.paymentDate);
                    var momentB = moment(b.paymentDate);
                    if ((momentA > momentB))
                        return asc ? 1 : -1;
                    if ((momentA < momentB))
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "purpose":
                sortHeader = this.$t("Purpose");
                result = mapSort(toSort, function (entry) {
                    return { purpose: entry.purpose ? entry.purpose.toLowerCase() : undefined };
                }, function (a, b) {
                    if (isNullOrUndefined(a.purpose) && isNullOrUndefined(b.purpose))
                        return 0;
                    if (isNullOrUndefined(a.purpose))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.purpose))
                        return asc ? -1 : 1;
                    if (a.purpose > b.purpose)
                        return asc ? 1 : -1;
                    if (a.purpose < b.purpose)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "state":
                sortHeader = this.$t("State");
                result = mapSort(toSort, function (entry) {
                    return { displayState: entry.displayState };
                }, function (a, b) {
                    if (a.displayState > b.displayState)
                        return asc ? 1 : -1;
                    if (a.displayState < b.displayState)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "subject":
                sortHeader = this.$t("Subject");
                result = mapSort(toSort, function (entry) {
                    return { displayTaskType: entry.displayTaskType };
                }, function (a, b) {
                    if (a.displayTaskType > b.displayTaskType)
                        return asc ? 1 : -1;
                    if (a.displayTaskType < b.displayTaskType)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            case "target":
                sortHeader = this.$t("AidTargetNumber");
                result = mapSort(toSort, function (entry) {
                    if (isNullOrUndefined(entry.aidTargetNumber))
                        return { aidTargetNumber: undefined, aidType: undefined };
                    var split = entry.aidTargetNumber.split(/(\d+)/);
                    if (split.length == 1)
                        return { aidTargetNumber: 0, aidType: split[0].trim().toLowerCase() };
                    else
                        return { aidTargetNumber: Number(split[1].trim()), aidType: split[0].trim().toLowerCase() };
                }, function (a, b) {
                    if (isNullOrUndefined(a.aidType) && isNullOrUndefined(b.aidType))
                        return 0;
                    if (isNullOrUndefined(a.aidType))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.aidType))
                        return asc ? -1 : 1;
                    if (a.aidType > b.aidType)
                        return asc ? 1 : -1;
                    if (a.aidType < b.aidType)
                        return asc ? -1 : 1;
                    if (isNullOrUndefined(a.aidTargetNumber) && isNullOrUndefined(b.aidTargetNumber))
                        return 0;
                    if (isNullOrUndefined(a.aidTargetNumber))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.aidTargetNumber))
                        return asc ? -1 : 1;
                    return asc ? a.aidTargetNumber - b.aidTargetNumber : b.aidTargetNumber - a.aidTargetNumber;
                });
                break;
            case "year":
                sortHeader = this.$t("Year");
                result = mapSort(toSort, function (entry) {
                    return { year: entry.year };
                }, function (a, b) {
                    if (isNullOrUndefined(a.year) && isNullOrUndefined(b.year))
                        return 0;
                    if (isNullOrUndefined(a.year))
                        return asc ? 1 : -1;
                    if (isNullOrUndefined(b.year))
                        return asc ? -1 : 1;
                    if (a.year > b.year)
                        return asc ? 1 : -1;
                    if (a.year < b.year)
                        return asc ? -1 : 1;
                    return 0;
                });
                break;
            default:
                break;
        }
        if (this.sortedAsc) {
            this.srSortedBy = this.$t("Accessibility.SortedAscendingAccordingToField", [sortHeader]);
        }
        else {
            this.srSortedBy = this.$t("Accessibility.SortedDescendingAccordingToField", [sortHeader]);
        }
        return result;
    };
    SortableTable.prototype.paymentMethod = function (paymentData) {
        var key = (paymentData.paymentBan)
            ? "Payments.PaymentMethods.PaymentBan"
            : "Payments.PaymentMethods." + PaymentMethod[paymentData.paymentMethod];
        return this.$t(key).toString();
    };
    SortableTable = __decorate([
        Component
    ], SortableTable);
    return SortableTable;
}(Vue));
export { SortableTable };
